import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    spanHeader: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        padding: "8px 32px 0",
    },
    spanValue: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: 16,
            fontWeight: 600,
            color: theme.palette.text.primary,
        },
    },
    content: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        padding: "16px 32px 0",
        maxHeight: "58vh",
        overflowY: "auto",
    },
    segmentCard: {
        border: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        borderRadius: 4,
        padding: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    segmentHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    segmentTitle: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: 14,
            color: theme.palette.info.main,
        },
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: 12,
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
    },
    fieldGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: theme.spacing(3),
    },
    field: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
    },
    fixedStart: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: 16,
            fontWeight: 400,
            color: theme.palette.text.primary,
            padding: "6px 0",
        },
    },
    dateTimePicker: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: 16,
            fontWeight: 400,
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
    },
    addSegmentRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4px 0 8px",
    },
    addSegmentButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: 12,
            textTransform: "uppercase",
            color: theme.palette.info.main,
        },
    },
    removeButton: {
        "&.MuiIconButton-root": {
            color: theme.palette.primary.dark,
        },
    },
    errorText: {
        "&.MuiTypography-root": {
            color: theme.palette.error.main,
            fontSize: 13,
            fontFamily: "Open Sans",
            minHeight: 18,
            padding: "4px 32px 0",
        },
    },
}));
